import { useSyncExternalStore } from 'react';

function subscribe(): () => void {
  return () => {};
}

/**
 * `false` při předrenderování i během hydratace, `true` hned po ní (React po hydrataci vykreslí
 * komponentu znovu s klientskou hodnotou, bez varování o neshodě). Pro obsah, který v předrenderovaném
 * HTML být nesmí nebo se v něm liší.
 */
export function useIsHydrated(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );
}
